import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <circle cx={8} cy={8} r={4.8} fill="#C4CBD5" />
    <path
      fill="#4C5157"
      d="M8.01.962a6.997 6.997 0 1 0 0 13.995 6.997 6.997 0 1 0 0-13.994ZM5.575 11.601l-1.139-1.132 2.49-2.506-2.505-2.49 1.132-1.14 2.506 2.491 2.491-2.506 1.139 1.132-2.491 2.506 2.506 2.49-1.132 1.14-2.506-2.49-2.49 2.505h-.001Z"
    />
  </svg>
);
export default SvgComponent;
